/* global Swiper */
function pastePagination($container, amount) {
  for (let i = 0; i < amount; i += 1) {
    $container.append(`<div class='share-pagination__line'><div class='anim-line' data-index=${i}></div></div>`);
  }
}

function animateSlideLine(swiper, $pagination) {
  let progressWidth = 0;
  let currIndex = swiper.realIndex;
  // TODO: disable for mobile
  function animateWidth() {
    if (currIndex !== swiper.realIndex) {
      currIndex = swiper.realIndex;
      progressWidth = 0;
    }
    if (progressWidth > 100) {
      progressWidth = 0;
      swiper.slideNext();
    }
    $pagination.find(`[data-index=${swiper.realIndex}]`).css({ width: `${progressWidth}%` });
    progressWidth += 0.25;

    requestAnimationFrame(animateWidth);
  }
  requestAnimationFrame(animateWidth);
}

function slideChanged(swiper, $pagination) {
  const $paginationLines = $pagination.find('.anim-line');
  $paginationLines.css({ width: 0 });

  animateSlideLine(swiper, $pagination);
}

$(() => {
  $('.js-share-slider').each(function sliderInit() {
    const $this = $(this);
    const $pagination = $this.find('.share-pagination');
    const sliderAmount = $this.find('.swiper-slide').length;

    pastePagination($pagination, sliderAmount);

    const swiper = new Swiper($this, {
      autoplay: false,
      slidesPerView: 1,
      spaceBetween: 0,
      effect: 'fade',
      loop: true,
      init: false,
      autoHeight: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    swiper.on('init', () => {
      slideChanged(swiper, $pagination);
    });
    swiper.init();

    swiper.on('slideChange', () => {
      slideChanged(swiper, $pagination);
    });
  });
});



// WEBPACK FOOTER //
// ./src/scripts/components/sliders/share-slider.js